import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { IncidentTypeService } from '../proxy/planning/controllers/incident-type.service';
import { IntensityService } from '../proxy/planning/controllers/intensity.service';

FieldBuilder.setNamespace('Planning');

export const INTENSITYDEGREE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('incidentTypeId', 'Entity.IncidentType', IncidentTypeService)
    .required()
    .displayFromNested('incidentType.name')
    .sortBy('incidentType.name')
    .build(),
  FieldBuilder
    .foreignKey('intensityId', 'Entity.Intensity', IntensityService)
    .required()
    .displayFromNested('intensity.name')
    .sortBy('intensity.name')
    .build(),
];

export const INTENSITYDEGREE_CONFIG = {
  entityName: 'IntensityDegree',
  localizationKey: 'Planning::Entity.IntensityDegree',
  fields: INTENSITYDEGREE_FIELDS,
  permission: 'ResearchAndDevelopmentIncident.IntensityDegrees',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Incident + MENU_NAME_SUFFIX,
};
